<template>
    <div>

        <div v-if="loading">
            <div id="controls"></div>
            Loading ...
        </div>
        <div v-else>
            <!-- Display props errors -->
            <div v-if='propsError'>
                <div v-for='error in errors' :key='error' class='text-danger'>{{ error }}</div>
            </div>

            <!-- If dont have eny error -->
            <div v-else>
                <div class="mt-3" style="display: block;">
                    <h4>{{ bank }}</h4>
                    <label for="description">Description</label>
                    <input v-if="description_editable" type="text" id="description" name="description" v-model='description' class="form-control">
                    <input v-else disabled type="text" :value="description" class="form-control">
                    <label for="cardHolderName">Cardholder name</label>
                    <input type="text" id="cardHolderName" name="cardHolderName" v-model='cardHolderName' class="form-control">
                    <label for="cardHolderEmail">Cardholder email</label>
                    <input type="text" id="cardHolderEmail" name="cardHolderEmail" v-model='cardHolderEmail' class="form-control">
                    <label for="customField">Custom field</label>
                    <input type="text" id="customField" name="customField" v-model='customField' class="form-control">

                    <button :disabled='disabled' class="btn btn-lg btn-primary btn-block mt-2 submitMonetawebReq" @click='submit'>Submit</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MyBank',
  props: {
    merchant_id: String,
    return_url: String,
    language: String,
    bank: String,
    amount: String,
    token: String,
    data: String,
    submitForm: Boolean
    },
    data: function() {
      return {
      propsError:false,
      errors: [],
      description: '',
      cardHolderName: '',
      cardHolderEmail: '',
      customField: '',
      disabled: false,
      clicked: false,
      loading: false,
      description_editable: false
  };
    },
    created(){
        // when clicked change value and excecute watch for clicked
        this.clicked = !this.clicked;

        // return error if is any error in prop
        if( !this.$props.return_url ){
            this.errors.push('Return Url prop is required')
            this.propsError = true
        }
        if( !this.$props.merchant_id ){
            this.errors.push('MerchantId prop is required')
            this.propsError = true
        }
        if( !this.$props.bank ){
            this.errors.push('Bank prop is required')
            this.propsError = true
        }
        if( isNaN(this.$props.amount) ){
            this.errors.push('Amount prop need to be number in format 5.99 or 10')
            this.propsError = true
        }
        if( this.$props.amount.toString().split('.')[1] ){
            if( this.$props.amount.toString().split('.')[1].length > 2 ){
                this.errors.push('Amount prop need to be number in format 5.99 or 10')
                this.propsError = true
            }
        }
        if( this.$props.amount < 0.05 ) {
            this.errors.push('The amount must be at least 0.05.')
            this.propsError = true
        }
        if (this.$props.bank == 'MONETAWEB' && !this.$props.language) {
            this.errors.push('Language prop is required')
            this.propsError = true
        }
        if( !this.$props.token ){
            this.errors.push('Token missing')
            this.propsError = true
        }
    },
    methods: {
        submit: function() {
            if (!this.propsError) {
                var self = this;
                this.disabled = true

                axios.post('https://gtn-gateway.draft2017.com/api/v2/orders',{
                    amount: this.$props.amount,
                    method: this.$props.bank.toLowerCase(),
                    merchant_order_id: this.$props.merchant_id,
                    language: this.$props.language,
                    description: this.description,
                    cardHolderName: this.cardHolderName,
                    cardHolderEmail: this.cardHolderEmail,
                    customField: this.customField,
                    return_url: this.$props.return_url
                },
                {
                    headers: {'Authorization': 'Bearer ' + this.$props.token}
                },
                )
                .then(response => (
                     window.location.href = response.data.redirect_url,
                     this.disabled = false
                  )
                )
                .catch(function (error) {
                    // handle error
                    self.errors.push(error.response.data.message)

                    // hande specific errors
                    if(error.response.data.errors.return_url) {
                        self.errors.push(error.response.data.errors.return_url[0])
                    }
                    if(error.response.data.errors.amount) {
                        self.errors.push(error.response.data.errors.amount[0])
                    }
                    if(error.response.data.errors.merchant_order_id) {
                        self.errors.push(error.response.data.errors.merchant_order_id[0])
                    }
                    if(error.response.data.errors.language) {
                        self.errors.push(error.response.data.errors.language[0])
                    }

                    self.propsError = true
                    self.disabled = false
                });
            }
        }
    },
    watch: {
        clicked: function () {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                this.description = object.description ? object.description : '';

                this.description_editable = typeof object.description_editable != 'undefined' ? ( object.description_editable == true ? true : false) : true;

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {
                        // fill inputs
                        // this.description = object.description ? object.description : '';
                        this.cardHolderName = object.cardName ? object.cardName : '';
                        this.cardHolderEmail = object.cardEmail ? object.cardEmail : '';
                        this.customField = object.customField ? object.customField : '';

                        // autosubmit
                        // if in props json data field autoSubmit is true
                        // if( object.autoSubmit ) {
                        //     if (this.$props.submitForm) {
                        //         this.submit();
                        //     }
                        // }
                    }
                }
            }
        },
        submitForm: function (value) {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {

                        // autosubmit
                        // if in props json data field autoSubmit is true
                        if( object.autoSubmit ) {
                            if (value) {
                                this.submit();
                                if (!this.propsError) {
                                    this.loading = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
